import React, { useEffect, useState} from 'react';
import {useAppSelector } from '../data-services/store';
import Imgix from "react-imgix";
import StarRating from "../../../../ui/rating/star-rating";
import {getIsChina} from "../../../../domain/hidden-data-provider";

/**
 * the entry point
 */
const AppMenuStickyLeft: React.FC = () => {

    const [isLoading, setIsLoading] = useState(false);

    // test -----------
    const productsRelDocsInitialSelected = useAppSelector((store) => store.productsRelDocsInitialSelected);
    const ImageCDNDomain = useAppSelector((store) => store.ImageCDNDomain);
    //console.log('productsRelDocsInitialSelected: ',productsRelDocsInitialSelected);
    /**
     * load initial data (drop-downs content) on page load once
     */
    useEffect(() => {
        (async () => {
            setIsLoading(false);
        })();
    }, []);



    return (
        <div className="my-2 ml-4">

            {
                !isLoading  &&
                <>
                    <div className="hidden md:block">
                        <div className="flex flex-wrap">
                            <div className="w-16 mr-2">
                                <Imgix
                                    src= {ImageCDNDomain + productsRelDocsInitialSelected.thumb}
                                    height={ 60 }
                                    htmlAttributes={{
                                        alt: productsRelDocsInitialSelected.documentName + " sticky image",
                                        loading: 'lazy',
                                    }}
                                />
                            </div>
                            <div className="w-auto pl-1 lg:w-64 flex flex-col justify-center">
                                <div
                                    className="text-gray-700 font-bold w-ellipsis w-line-clamp-2"
                                    dangerouslySetInnerHTML={{ __html: productsRelDocsInitialSelected?.documentName?.replaceAll("®", "<sup>®</sup>") || '' }}
                                />

                                {!getIsChina() &&<div className="">
                                    <StarRating
                                        rating={ productsRelDocsInitialSelected.rating }
                                        reviews={ productsRelDocsInitialSelected.reviewsTotal }
                                        url={ productsRelDocsInitialSelected.documentUrlPath }
                                        urlHash={ 'tab-reviews' }
                                        className=""
                                        colorClass="text-blue-200"
                                    />
                                </div>}
                            </div>
                        </div>
                    </div>
                    <div className="md:hidden font-bold w-ellipsis w-line-clamp-2">
                        {productsRelDocsInitialSelected?.documentName}
                    </div>
                </>
            }

        </div>
    )
};

export default AppMenuStickyLeft;